import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { PortalManagementTransactionsService } from 'src/app/features/portal/_services/management/portal-management-transactions.service';

@Component({
  selector: 'app-transaction-override-dialog',
  templateUrl: './transaction-override-dialog.component.html',
  styleUrls: ['./transaction-override-dialog.component.scss'],
  providers: [DatePipe, PortalManagementTransactionsService]
})
export class TransactionOverrideDialogComponent implements OnInit {
  data: any;
  selectedDate: any;
  loading: boolean = false;
  selectedReason: any;
  overrideReasons = [
    {
      label: 'Payment made via bank deposit',
      value: 'Payment made via bank deposit'
    }
  ];

  constructor(
    private pmts: PortalManagementTransactionsService,
    private config: DynamicDialogConfig,
    private datePipe: DatePipe,
    private ref: DynamicDialogRef,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.data = this.config.data.transaction;
    console.log('data', this.data);
  }

  overrideTransaction() {
    this.loading = true;
    if (this.selectedDate) {
      const formattedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      console.log('formattedDate', formattedDate);

      const data = {
        transaction_date: formattedDate,
        comment_reason: this.selectedReason
      };

      this.pmts.overrideTransactionPaymentMethod(data, this.data.id).subscribe(
        (res: any) => {
          console.log('res', res);

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Transaction has been successfully overridden',
            key: 'overrideTransaction'
          });
          this.ref.close(res);
        },
        (error: any) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred while overriding transaction',
            key: 'overrideTransaction'
          });
        }
      );
    } else {
      this.loading = false;
    }
  }
}
